import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Category {
  name: string;
  url: string;
  imageUrl: string;
}

const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20white%20sneakers%20on%20wooden%20floor%20with%20natural%20sunlight%20streaming%20through%20window%2C%20lifestyle%20photography%2C%20casual%20home%20setting%20with%20plants%20in%20background%2C%20warm%20golden%20hour%20lighting%2C%20editorial%20lifestyle%20aesthetic%2C%20cozy%20modern%20interior%2C%20soft%20shadows%2C%20relaxed%20weekend%20vibe&width=400&height=300&seq=yoybuy-dd-shoes&orientation=landscape',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20draped%20over%20vintage%20chair%20in%20sunlit%20room%2C%20warm%20afternoon%20light%20streaming%20through%20blinds%2C%20lived-in%20aesthetic%2C%20textured%20fabric%20detail%20visible%2C%20Scandinavian%20interior%20with%20neutral%20walls%2C%20lifestyle%20fashion%20photography%2C%20soft%20focus%20background%2C%20comfortable%20home%20atmosphere&width=400&height=300&seq=yoybuy-dd-hoodies&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20cotton%20t-shirt%20hanging%20on%20wooden%20hanger%20against%20exposed%20brick%20wall%2C%20industrial%20chic%20setting%2C%20natural%20window%20light%20from%20side%2C%20minimal%20styling%20with%20small%20potted%20plant%20on%20side%20table%2C%20editorial%20fashion%20photography%2C%20warm%20earthy%20tones%2C%20urban%20loft%20aesthetic&width=400&height=300&seq=yoybuy-dd-tshirts&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Denim%20jacket%20laid%20flat%20on%20rustic%20wooden%20surface%20with%20autumn%20leaves%20scattered%20around%2C%20top-down%20flatlay%20composition%2C%20soft%20diffused%20light%2C%20warm%20amber%20and%20rust%20tones%2C%20editorial%20product%20styling%2C%20cozy%20fall%20atmosphere%2C%20seasonal%20fashion%20photography&width=400&height=300&seq=yoybuy-dd-jackets&orientation=landscape',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Linen%20trousers%20folded%20neatly%20on%20marble%20surface%20with%20morning%20coffee%20cup%2C%20minimalist%20bathroom%20setting%2C%20soft%20natural%20light%20from%20large%20window%2C%20clean%20spa-like%20aesthetic%2C%20fresh%20morning%20vibe%2C%20elegant%20product%20styling%2C%20serene%20and%20peaceful%20composition&width=400&height=300&seq=yoybuy-dd-pants&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Baseball%20cap%20resting%20on%20stack%20of%20fashion%20magazines%20on%20glass%20coffee%20table%2C%20modern%20living%20room%20background%2C%20warm%20afternoon%20sunlight%20streaming%20in%2C%20lifestyle%20editorial%20style%2C%20warm%20beige%20and%20cream%20tones%2C%20relaxed%20weekend%20atmosphere%2C%20casual%20chic%20aesthetic&width=400&height=300&seq=yoybuy-dd-headwear&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20sweatsuit%20set%20displayed%20on%20minimalist%20mannequin%20against%20soft%20pink%20studio%20backdrop%2C%20fashion%20boutique%20aesthetic%2C%20soft%20studio%20lighting%20from%20above%2C%20elegant%20minimal%20presentation%2C%20high-end%20catalog%20quality%2C%20clean%20composition%2C%20modern%20retail%20display&width=400&height=300&seq=yoybuy-dd-sets&orientation=landscape',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20basics%20folded%20in%20neat%20stack%20on%20linen%20bedspread%2C%20soft%20morning%20light%20through%20sheer%20curtains%2C%20serene%20bedroom%20setting%2C%20intimate%20lifestyle%20photography%2C%20clean%20minimalist%20aesthetic%2C%20warm%20neutral%20palette%2C%20calm%20and%20peaceful%20morning%20atmosphere&width=400&height=300&seq=yoybuy-dd-underwear&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sports%20jersey%20hanging%20in%20locker%20room%20with%20dramatic%20side%20lighting%2C%20athletic%20atmosphere%2C%20moody%20shadows%20creating%20depth%2C%20professional%20sports%20photography%20style%2C%20textured%20fabric%20detail%20visible%2C%20energetic%20yet%20sophisticated%2C%20stadium%20locker%20room%20setting&width=400&height=300&seq=yoybuy-dd-jersey&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20watch%20and%20sunglasses%20arranged%20on%20dark%20velvet%20surface%20with%20jewelry%20box%20open%2C%20luxury%20product%20flatlay%2C%20dramatic%20spotlight%20lighting%20from%20above%2C%20dark%20elegant%20background%2C%20high-end%20catalog%20photography%2C%20reflective%20surfaces%20catching%20light%2C%20sophisticated%20premium%20aesthetic&width=400&height=300&seq=yoybuy-dd-accessories&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Leather%20backpack%20placed%20on%20vintage%20cafe%20chair%20with%20fresh%20croissant%20and%20espresso%20coffee%20cup%2C%20Parisian%20cafe%20terrace%20setting%20with%20cobblestone%20visible%2C%20warm%20morning%20sunlight%2C%20lifestyle%20travel%20aesthetic%2C%20charming%20European%20atmosphere%2C%20soft%20golden%20tones&width=400&height=300&seq=yoybuy-dd-bags&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Braided%20leather%20belt%20artistically%20coiled%20on%20polished%20concrete%20surface%2C%20modern%20industrial%20studio%20setting%2C%20dramatic%20overhead%20spotlight%2C%20sharp%20geometric%20shadows%2C%20editorial%20product%20photography%2C%20monochromatic%20warm%20palette%2C%20sculptural%20composition&width=400&height=300&seq=yoybuy-dd-belts&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20on%20white%20marble%20vanity%20with%20fresh%20peony%20flowers%20beside%20it%2C%20luxurious%20bathroom%20setting%2C%20soft%20diffused%20window%20light%2C%20feminine%20elegant%20aesthetic%2C%20rose%20gold%20accents%20and%20details%2C%20sophisticated%20product%20styling%2C%20spa%20luxury%20atmosphere&width=400&height=300&seq=yoybuy-dd-perfumes&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20mix%20of%20lifestyle%20products%20in%20woven%20basket%20on%20colorful%20bohemian%20rug%2C%20curated%20collection%20flatlay%2C%20warm%20afternoon%20light%20streaming%20through%20window%2C%20artistic%20composition%2C%20creative%20studio%20atmosphere%2C%20diverse%20textures%20and%20materials%2C%20boho%20chic%20aesthetic&width=400&height=300&seq=yoybuy-dd-other&orientation=landscape',
  },
];

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);

  const handleSelect = (cat: Category) => {
    setSelectedCategory(cat);
    setIsOpen(false);
    window.open(cat.url, '_blank', 'noopener,nofollow');
  };

  return (
    <section id="categories" className="w-full px-4 md:px-10 py-12 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-2">
          {t('categories.title')}
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-10">
          {t('categories.subtitle')}
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center p-3 md:p-4 rounded-2xl bg-background-50 hover:bg-background-200 transition-all cursor-pointer"
            >
              <div className="w-full aspect-square rounded-xl overflow-hidden mb-3">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-accent-600 transition-colors text-center whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>

        <div className="relative max-w-md mx-auto mt-8">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-5 py-4 rounded-2xl bg-background-50 border-2 border-background-300 hover:border-accent-400 transition-all text-left cursor-pointer"
          >
            <span className={`text-sm ${selectedCategory ? 'text-foreground-900 font-medium' : 'text-foreground-400'}`}>
              {selectedCategory ? selectedCategory.name : t('dropdown.placeholder')}
            </span>
            {isOpen ? (
              <i className="ri-arrow-up-s-line text-foreground-500 w-5 h-5 flex items-center justify-center"></i>
            ) : (
              <i className="ri-arrow-down-s-line text-foreground-500 w-5 h-5 flex items-center justify-center"></i>
            )}
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-2xl shadow-lg z-50 max-h-72 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat)}
                  className="w-full text-left px-5 py-3 text-sm text-foreground-700 hover:bg-accent-50 hover:text-accent-600 transition-colors first:rounded-t-2xl last:rounded-b-2xl cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </button>
              ))}
            </div>
          )}
        </div>

        {selectedCategory && (
          <p className="mt-3 text-xs text-foreground-400">
            {selectedCategory.name} — {t('dropdown.opened')}
          </p>
        )}
      </div>
    </section>
  );
}